import { styled, Box } from "@mui/material";

export const ContainerModalStyled = styled(Box)(() => ({
  backgroundColor: "#ededed",
  width: "400px",
  margin: "0 auto",
  height: "fit-content",
  borderRadius: "24px",
  padding: "24px 0 8px 0",
  marginTop: "20vh",
  color: "#0F110C",
  boxShadow: "0 4px 24px 0 rgba(0,0,0,0.15)",
}));

export const ContainerActions = styled(Box)(() => ({
  display: "flex",
  gap: "8px",
  justifyContent: "flex-end",
  borderTop: "1px solid #CBCBCB",
  padding: "8px 24px 0 24px",
}));
